<template>
  <v-row>
    <v-col cols="12" md="4" v-if="groups.length > 1">
      <v-select
          class="input-activation"
          v-model="product_body.group"
          :items="groups"
          label="Grupo"
          item-text="name"
          no-data-text="Selecione"
          return-object
          required
      ></v-select>
    </v-col>
    <v-col cols="12" md="4">
      <v-select
          class="input-activation"
          v-model="product_body.category"
          :items="categories"
          label="Categoria"
          item-text="name"
          no-data-text="Selecione"
          return-object
          required
      ></v-select>
    </v-col>
    <v-col cols="12" md="4">
      <v-select
          class="input-activation"
          v-model="product_body.product"
          :items="products"
          label="Tempo"
          item-text="name"
          no-data-text="Selecione"
          return-object
          required
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "SelectProduct",
  props: {
    value: {
      type: Object,
    },
    vehicle: {
      type: Object,
    }
  },
  data: function () {
    return {
      raw_rule: null,
    }
  },
  mounted() {
    this.loadProducts();
  },
  methods: {
    async loadProducts() {
      const {data: response} = await axios.get(
          "/api/v2/demarcation/parking/products", {params: {plate: this.vehicle.plate}}
      );

      this.raw_rule = response;
    },
    getTargetSlug() {
      let id_to_search = this.vehicle && this.vehicle.vehicle_type && this.vehicle.vehicle_type.id || 6;

      switch (id_to_search) {//change to get the vehicle object vehicle.vehicle_type?.id || 6
        default:
          return 'common';
        case 11:
        case 14:
          return 'load_unload';
        case 3:
        case 4:
          return 'motorcycle';
      }
    },
    preSelectedBestGroupIndex(groups) {
      const groupsSortedByPriority = groups.sort(
          (a, b) => a.priority - b.priority,
      );

      let targetGroupId = groupsSortedByPriority[0].id;

      return groups.findIndex(el => el.id === targetGroupId);
    },
    preSelectedBestCategoryIndex(categories) {
      const targetSlug = this.getTargetSlug();

      let index = categories.findIndex(category => category.slug === targetSlug);

      if (index === -1) { //fallback
        index = categories.findIndex(category => category.slug === 'common');
      }

      if (index === -1) {
        index = 0;
      }

      return index;
    },
  },
  watch: {
    "groups": function (newVal) {
      let value_to_set = null;
      if (newVal.length > 0) {
        const index  = this.preSelectedBestGroupIndex(newVal);
        value_to_set = newVal[index];
      }
      this.product_body.group = value_to_set;
    },
    "categories": function (newVal) {
      let value_to_set = null;
      if (newVal.length > 0) {
        const index  = this.preSelectedBestCategoryIndex(newVal);
        value_to_set = newVal[index];
      }
      this.product_body.category = value_to_set;
    },
    "product_body.category": {
      handler: function () {
        this.product_body.product = null;
      },
    },
  },
  computed: {
    groups: function () {
      if (!this.raw_rule) {
        return [];
      }

      if (!this.raw_rule.groups) {
        return [];
      }

      return this.raw_rule.groups.map((el) => ({
        ...el,
        id: el.id,
        name: el.name,
      }));
    },
    categories: function () {
      if (!this.product_body.group) {
        return [];
      }

      return this.product_body.group.categories.map((el) => ({
        ...el,
        id: el.id,
        name: el.name,
      }));
    },
    products: function () {
      if (!this.product_body.category) {
        return [];
      }

      return this.product_body.category.products.map((el) => ({
        ...el,
        id: el.id,
        name: `R$ ${this.formatMoney(el.price, true)} - ${el.time} min`,
      }));
    },
    product_body: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
}
</script>

<style scoped>
</style>
